import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // ✅ Import navigate hook
import axios from "axios";
import "./LoginPage.css";
import FRONTEND_CONFIG from "./frontend_config";

const LoginPage = () => {
  const [applicationId, setApplicationId] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [toast, setToast] = useState(""); // ✅ State for styled middle alert
  const navigate = useNavigate(); // ✅ Initialize navigate

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await axios.post(`${FRONTEND_CONFIG.API_URL}/api/applicant/login`, {
        email,
        applicationId,
      });

      if (res.status === 200) {
        // ✅ Show middle toast instead of alert
        setToast("Login successful! Redirecting...");
        setTimeout(() => setToast(""), 2000); // Hide toast after 2 seconds

        // Save dashboard data
        localStorage.setItem("dashboardData", JSON.stringify(res.data.dashboardData));

        // Redirect after 2 seconds
        setTimeout(() => navigate("/applicant-dashboard"), 2000);
      }
    } catch (err) {
      if (err.response) {
        setError(err.response.data.message || "Login failed. Try again.");
      } else {
        setError("Server not reachable. Please try again later.");
      }
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-box">

        <div className="left-section">
          <h2>Login</h2>

          <form onSubmit={handleSubmit}>
            <label>Application ID</label>
            <input
              type="text"
              value={applicationId}
              onChange={(e) => setApplicationId(e.target.value)}
              required
            />

            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            {error && <p className="error-msg">{error}</p>}

            <button type="submit" className="login-btn">Login</button>

           
          </form>
        </div>

        <div className="right-section">
          <h1>WELCOME<br /></h1>
          <p>To our Exam portal.</p>
        </div>

      </div>

      {/* ✅ Styled middle toast */}
      {toast && (
        <div className="toast">
          {toast}
        </div>
      )}
    </div>
  );
};

export default LoginPage;
